import React from 'react';
import { styled } from '@nykaa/ui-components';
import { hexToRgb } from '@nykaa/ui-components/styles/utils';
const Root = styled.div `
  background: ${({ bgColor, theme }) => bgColor || hexToRgb(theme.colors.primary, 0.08)};
  border-radius: ${({ border, theme }) => border || theme.borders.radius20};
  padding: ${({ theme: { spacing } }) => `${spacing.spacing10} ${spacing.spacing20}`};
  margin-bottom: ${({ theme }) => theme.spacing.spacing20};
  overflow: hidden;
`;
const Title = styled.div `
  ${({ theme }) => theme.typography.subTitleSmall};
  color: ${({ theme, color }) => color || theme.colors.primary40};
`;
Title.displayName = 'Title';
const PriceInfo = styled.div `
  display: flex;
  align-items: center;
  ${({ theme }) => theme.typography.labelMedium};
  color: ${({ theme, color }) => color || hexToRgb(theme.colors.textPrimary, 0.92)};
`;
PriceInfo.displayName = 'PriceInfo';
const Discount = styled.span `
  ${({ theme }) => theme.typography.labelSmall};
  color: ${({ theme, color }) => color || theme.colors.positive};
  margin-left: ${({ theme }) => theme.spacing.spacing10};
`;
const PriceReveal = ({ prData, listingPriceReveal, }) => {
    const { isActive = false, title: configTitle, styles, } = listingPriceReveal || {};
    const { titleColor: configTitleColor, border: configBorderRadius, bgColor: configBgColor, spColor: configSpColor, discountColor: configDiscountColor, } = styles || {};
    const { templateType, text: prTitle, discount, price, textColor, priceColor, discountColor: prDiscountColor, borderRadius, bgColor: prBgColor, } = prData || {};
    const updatedPrData = {
        title: prTitle || configTitle,
        border: (borderRadius && `${borderRadius}px`) || configBorderRadius,
        bgColor: prBgColor || configBgColor,
        titleColor: textColor || configTitleColor,
        spColor: priceColor || configSpColor,
        discountColor: prDiscountColor || configDiscountColor,
    };
    const { title, border, bgColor, titleColor, spColor, discountColor, } = updatedPrData;
    if (isActive && (price || templateType)) {
        return (React.createElement(Root, { bgColor: bgColor, border: border },
            React.createElement(Title, { color: titleColor }, title),
            price && (React.createElement(PriceInfo, { color: spColor },
                "\u20B9",
                price,
                discount ? React.createElement(Discount, { color: discountColor }, `(${discount}%)`) : null))));
    }
    return null;
};
export default PriceReveal;
